import {Property} from "../../../../models/Property";
import React, {Fragment} from "react";
import {Grid} from "@material-ui/core";
import PropertyCard from "./PropertyCard";
import {useSelector} from "../../../../redux/store";
import {getCompanies} from "../../../../selectors";

export type RenderPropertiesProps = {
  properties: Property[];
  onClick: (id: string) => void;
  onEdit: (id: string) => void;
  onEditFacilities: (id: string) => void;
  companyName?: string
}

const RenderProperties = (p: RenderPropertiesProps) => {
  const { properties, ...rest } = p;
  const companies = useSelector<any>(getCompanies)

  const getCompanyNameById = (companyId: string | undefined) => {
    if (companies?.length > 0 && companyId) {
      const findCompany = companies.find((i: any) => i.id === companyId)
      return findCompany ? findCompany.name : ''
    }
    return ''
  }

  return (
    <Fragment>
      {properties.map((item, index) => {
        return (
          <Grid item md={4} sm={6} xs={12} lg={3} key={index}>
            <PropertyCard {...rest} item={item} companyName={getCompanyNameById(item.company)}/>
          </Grid>
        )
      })}
    </Fragment>
  )
}

export default RenderProperties